import accessorCertificateRequest from '@/api/academic/accessor-certificate-request'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
    ...baseState,
    formViewDatas: [],
    approveDatas: [],
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_VIEW_MODELS(state, { data, index }) {
        if (!index) {
            state.formViewDatas = data;
        } else {
            split(index, ",").forEach(el => {
                state.formViewDatas[el] = data[el];
            });
        }
    },
    SET_APPROVE_REQUEST(state, { data, index }) {
        if (!index) {
            state.approveDatas = data;
        } else {
            split(index, ",").forEach(el => {
                state.approveDatas[el] = data[el];
            });
        }
    }
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attrubutes
        )
        return accessorCertificateRequest.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store(context, data) {
        return accessorCertificateRequest.store(data)
    },
    update(context, { id, data }) {
        return accessorCertificateRequest.update(id, data)
    },
    isReject(context, { id, data }) {
        return accessorCertificateRequest.isReject(id, data)
    },
    async approve(context, { params, index }) {
        let response = await accessorCertificateRequest.approve({ params: params });
        context.commit("SET_APPROVE_REQUEST", {
            data: response.data,
            index: index
        });
        return Promise.resolve(response);
    },
    destroy(context, id) {
        return accessorCertificateRequest.destroy(id)
    },
    async getFormViewData(context, { params, index }) {
        let response = await accessorCertificateRequest.formModel({ params: params });
        context.commit("SET_VIEW_MODELS", {
            data: response.data,
            index: index
        });
        return Promise.resolve(response);
    },
}
